import { createAction, props } from '@ngrx/store';
import { CommonData } from '../interfaces/common-data';
import {CrmSubAgent} from "../interfaces/crm-sub-agent";
import {CrmItem} from "../interfaces/crm-item";

export const requestCommonData = createAction(
	'[Core API] Request common data'
);

export const loadCommonData = createAction(
	'[Core API] Load common data'
);

export const requestDictionaries = createAction(
  '[Core API] Request dictionaries'
);

export const loadDictionaries = createAction(
  '[Core API] Load dictionaries'
);

export const setDictionaries = createAction(
  '[Core API] Set dictionaries',
  props<{dictionaries: any}>()
);

export const setCommonData = createAction(
	'[Core API] Set common data',
	props<{commonData: CommonData|undefined}>()
);

export const logout = createAction(
	'[Core API] Logout'
);

export const reset = createAction(
	'[Core API] Reset'
);

export const setPageTitle = createAction(
	'[Core API] Set page title',
	props<{title: string|undefined}>()
);

export const unauthorizedError = createAction(
	'[Core API] Unauthorized error'
);

export const serverError = createAction(
	'[Core API] Server error',
	props<{message?: string}>()
);

export const updateInstanceId = createAction(
  '[Core API] Update instance id',
  props<{instanceId?: number}>()
);

export const updateCrmInstanceId = createAction(
  '[Core API] Update crm instance id',
  props<{crmId?: number}>()
);

export const downloadZip = createAction(
  '[Core API] Download ZIP file',
  props<{fileName: string, base64string: string}>()
);

export const requestCrmSubAgents = createAction(
  '[CRM API] Request sub agents'
);

export const requestCrmSubAgentsSuccess = createAction(
  '[CRM API] Request sub agents success',
  props<{ subAgents: CrmSubAgent[] }>()
);

export const loadFailureReasons = createAction(
  '[Requests API] Load failure reasons'
);

export const loadFailureReasonsSuccess = createAction(
  '[CRM API] Load failure reasons success',
  props<{ failureReasons: CrmItem[] }>()
);

export const requestBaseContracts = createAction(
  '[CRM API] Request base contracts',
  props<{ id: string }>()
);

export const requestBaseContractsSuccess = createAction(
  '[CRM API] Request base contracts success',
  props<{ contracts: CrmItem[] }>()
);

